import React from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Form as SemanticForm } from "semantic-ui-react";
import { required, composeValidators } from "../../utils/formValidation";

export type CustomFormFieldProps = {
  name: string;
  type?: string;
  value?: any;
  render: (...args: any[]) => React.ReactElement;
  initialValue?: any;
  validators?: CustomFieldValidator[];
  required?: boolean;
};

export type CustomFieldValidator = (value: string) => any;
export type CustomFormValidator = (values: Record<string, any>) => any;

type FormProps = {
  fields: CustomFormFieldProps[];
  validate?: CustomFormValidator;
  onSubmit: (...args: any[]) => void;
  submitText?: string;
};

const Form = ({ fields, onSubmit, submitText, validate }: FormProps) => (
  <FinalForm
    onSubmit={onSubmit}
    validate={validate}
    render={({ handleSubmit, invalid, dirty, validating }) => (
      <SemanticForm onSubmit={handleSubmit}>
        {fields.map(field => (
          <Field
            key={field.name + field.value}
            type={field.type}
            value={field.value}
            name={field.name}
            component={field.render}
            initialValue={field.initialValue}
            validate={composeValidators(required(field.required), ...(field.validators || []))}
          />
        ))}
        <SemanticForm.Button disabled={invalid || !dirty || validating} type="submit">
          {submitText || "Submit"}
        </SemanticForm.Button>
      </SemanticForm>
    )}
  />
);

export default Form;
